import "Common/paginator";

const $sort = $("#filter-sort"),
    $fakeSortButtons = $(".js-fake-sort-buttons"),
    $view = $("#filter-view"),
    $fakeView = $(".js-fake-view");

const changeFakeSortButton = (value) => {
    $fakeSortButtons.find(".c-btn").removeClass("is-active");
    $fakeSortButtons.find(`.c-btn[data-value="${value}"]`).addClass("is-active");
};

function showAvailabilityInfo(id) {
    $(".js-availability-info").hide();
    $(".js-availability-info#" + id).show();
}

$(function () {
    // fake sort
    const sortValue = $sort.val();

    if (sortValue) {
        changeFakeSortButton(sortValue);
    }

    $fakeSortButtons.on("click", ".c-btn", function () {
        const value = $(this).data("value");

        changeFakeSortButton(value);
        $sort.val(value).trigger("change");
    });

    // fake view
    let viewValue = getCookie("listingView");

    if (viewValue) {
        $(".js-fake-view#" + viewValue).addClass("is-active");
    } else {
        $(".js-fake-view#grid").addClass("is-active");
    }

    $fakeView.on("click", function () {
        viewValue = $(this).data("value");

        $view.val(viewValue).change();
    });

    rEvent.on("Listing.changeView", function () {
        const $view = $("#filter-view"),
            value = $view.val();

        $(".js-fake-view").removeClass("is-active");
        $(".js-fake-view#" + value).addClass("is-active");

        $(".products").removeClass("products--row").removeClass("products--grid");
        $(".products").addClass("products--" + value);

        $(".products .js-thumb").removeClass("is-row").removeClass("is-grid");
        $(".products .js-thumb").addClass("is-" + value);
    });

    $('[name="filter[custom_availability]"]').on("change", function (event) {
        showAvailabilityInfo(this.value);
    });

    showAvailabilityInfo($('[name="filter[custom_availability]"]').val());
});

rEvent.on("Listing.fetchedData", function (data) {
    const $listingCount = $(".js-listing-count");

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr("data-plural")) {
                const listingPlural = $countElem.data("plural");

                countHtml =
                    data.count +
                    " " +
                    Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr("data-template")) {
                countHtml = $countElem.data("template").replace(":value:", countHtml);
            }

            $countElem.html(countHtml);
        });
    }
});
